export const CDN_DOMAIN = "https://d3mn3kpb7oflmx.cloudfront.net";
export const ASSETS_PATH = "/SITO%20ASSET";
export const CDN_URL = `${CDN_DOMAIN}${ASSETS_PATH}`;
